module.exports = __webpack_public_path__ + "static/media/wechat.efa597cd.png";